/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import {
	InnerBlocks,
} from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { withDispatch, select } from '@wordpress/data';
import { compose } from '@wordpress/compose';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
// import { appendStyleTag } from '../../../extensions/custom-styles';
import BaseWrapper from '../../../components/base-wrapper';
// import TestimonailItemStyle from './inline-styles';

const ALLOWED_BLOCKS = [ 'core/social-links' ];

const getInnerBlockTemplate = () => {
	return [
		[ 'core/image', {
			url: `${ window.gutenify_block_data.plugin_directory_url }assets/images/profile-pic.jpg`,
			align: 'center',
			className: 'is-style-rounded',
			width: 100,
			height: 100,
		} ],
		[
			'core/paragraph',
			{
				content: __( 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet est massa. Sed enim massa, mattis at libero nec, bibendum ultricies augue.' ),
				level: 3,
				placeholder: __( 'Title' ),
				align: 'center',
				className: 'gutenify-testimonial-block-content',
			},
		],
		[
			'core/heading',
			{
				content: __( 'Jane Doe' ),
				level: 3,
				placeholder: __( 'Title' ),
				textAlign: 'center',
				className: 'gutenify-testimonial-block-full-name',
			},
		],
		[
			'core/heading',
			{
				content: __( 'Founder/ CEO' ),
				level: 4,
				placeholder: __( 'Degination' ),
				textAlign: 'center',
				className: 'gutenify-testimonial-block-degination',
				// style: { typography: { textTransform: 'capitalize' } },
			},
		],
		// [ 'core/social-links' ],
		[ 'gutenify/star-rating' ],
	];
};

const Edit = ( props ) => {
	const { isSelected, className, attributes } = props;
	const { layout, blockClientId } = attributes;
	const wrapperClasses = classnames(
		className,
		`gutenify-testimonial-${ layout }`,
		`gutenify-section-${ blockClientId }`,
	);
	return (
		<div className={ wrapperClasses }>
			<BaseWrapper { ...props }>
				{ isSelected && <Inspector { ...props } /> }
				<InnerBlocks
					allowedBlocks={ ALLOWED_BLOCKS }
					template={ getInnerBlockTemplate() }
					templateLock="all"
					templateInsertUpdatesSelection={ false }
				/>
			</BaseWrapper>
		</div>
	);
};

export default compose( [
	withDispatch( ( dispatch, props ) => {
		const { clientId } = props;

		return {
			updateInnerBlocks( template ) {
				const children = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ].innerBlocks;
				children.forEach( function( child ) {
					if ( 'core/image' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { align: template.imageAlign } );
					}
					if ( 'core/heading' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { textAlign: template.titleAlign } );
					}
					if ( 'core/paragraph' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { align: template.titleAlign } );
					}
					if ( 'gutenify/star-rating' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { textAlignment: template.ratingAlign } );
					}
				} );
			},
		};
	} ),
] )( Edit );
